export const reduceUserInformation = (user) => ({
  email: user.email,
  name: user.name,
  user_id: user.user_id,
})
